import { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { Link } from "react-router-dom";
import SideCategoryMenu from "./SideCategoryMenu";
import { getCategories } from "../api/api"; 
import "./CategoryNavbar.css";

function CategoryNavbar() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sideOpen, setSideOpen] = useState(false);

  useEffect(() => {
    getCategories()
      .then((data) => {
        if (Array.isArray(data)) setCategories(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="categoryBar">
      {/* ALL CATEGORIES - Fixed on Left */}
      <div className="allCategories" onClick={() => setSideOpen(true)}>
        <FaBars />
        <span>All</span>
      </div>

      {/* SCROLLABLE LINKS */}
      <ul className="categoryLinks">
        {loading ? (
          <li className="loading-text">...</li>
        ) : (
          // Top menu compact rakho; baaki categories "All" side menu me dikhenge.
          categories
            .filter((cat) => cat.parent === 0) 
            .slice(0, 5)
            .map((cat) => (
              <li key={cat.id}>
                <Link to={`/category/${cat.slug}`}>{cat.name}</Link>
              </li>
            ))
        )}
        <li className="staticMenu">
          <Link to="/about">About</Link>
        </li>
        <li className="staticMenu">
          <Link to="/contact">Contact</Link>
        </li>
        <li className="b2bMenu">
          <Link to="/b2b">B2B Deals</Link>
        </li>
      </ul>

      {/* SIDE MENU */}
      <SideCategoryMenu
        categories={categories}
        isOpen={sideOpen}
        setIsOpen={setSideOpen}
      />
    </div>
  );
}

export default CategoryNavbar;
